module.exports = __webpack_public_path__ + "static/media/fileupload-icon.4430c8c8.svg";